import React, { useState, useEffect } from "react";
import {
  MdPhoneAndroid,
  MdComputer,
  MdLanguage,
  MdLocalFireDepartment,
  MdCloud,
  MdLightbulb,
  MdInfo,
} from "react-icons/md";
import kodeImg from "./assets/images/kode.jpg"; // adjust path if needed
import backgroundImg from "./assets/images/tax.png";

function ServicesSection() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    function onScroll() {
      setScrollY(window.scrollY);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const visible = scrollY > 200;

  const services = [
    { icon: MdPhoneAndroid, label: "Mobile App Development", color: "#3DDC84" },
    { icon: MdComputer, label: "Desktop App Development", color: "#4285F4" },
    { icon: MdLanguage, label: "Web development", color: "#A9A9A9" },
    { icon: MdLocalFireDepartment, label: "Firebase integration", color: "#ff9100" },
    { icon: MdCloud, label: "Backend Integration & APIs", color: "#90CAF9" },
    { icon: MdLightbulb, label: "MVP Prototyping", color: "#FFEB3B" },
  ];

  const containerStyle = {
    position: "relative",
    maxWidth: 660,
    width: "100%",
    margin: "auto",
    padding: 30,
    borderRadius: 18,
    color: "#D3D3D3",
    fontFamily: "MyCustomFont, sans-serif",
    backgroundColor: "transparent",
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0)" : "translateY(20px)",
    transition: "opacity 0.5s ease, transform 0.5s ease",
    boxSizing: "border-box",
    overflow: "hidden", // ensures border follows rounded corners
  };

  // Gradient border overlay
  const borderOverlayStyle = {
    position: "absolute",
    inset: 0,
    borderRadius: 24,
    padding: 5, // border thickness
    background: "linear-gradient(135deg, #114a2b, #083042)",
    WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0) border-box",
    WebkitMaskComposite: "destination-out",
    maskComposite: "exclude",
    pointerEvents: "none",
  };

  const rowStyle = {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 20,
  };

  const serviceColumnStyle = {
    flex: "1 1 120px",
    minWidth: 100,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    color: "gray",
  };

  return (
    <div style={containerStyle}>
      <div style={borderOverlayStyle} /> {/* gradient border */}
      <div style={{ position: "relative", zIndex: 1 }}>
        <h2 style={{ fontSize: 22, fontWeight: "bold", marginBottom: 40, color: "lightgray" }}>
          Vores Services
        </h2>

        <div style={rowStyle}>
          {services.map(({ icon: Icon, label, color }, i) => (
            <div key={i} style={serviceColumnStyle}>
              <Icon size={64} color={color} />
              <div style={{ height: 12 }} />
              <p style={{ fontSize: 14 }}>{label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}



function AboutSectionPlayful() {
  const outerStyle = {
    position: "relative",
    maxWidth: 660,
    width: "100%",
    margin: "40px auto",
    borderRadius: 18,
    padding: 5,
    boxSizing: "border-box",
    background: `
      radial-gradient(circle at 20% 30%, #083042 0%, transparent 50%),
      radial-gradient(circle at 75% 60%, #114a2b 0%, transparent 40%),
      conic-gradient(
        from 45deg,
        #083042 0%,
        #114a2b 15%,
        #084d42 28%,
        #11664b 45%,
        #083042 60%,
        #114a2b 78%,
        #083042 100%
      )
    `,
    backgroundBlendMode: "overlay",
  };

  const innerStyle = {
    borderRadius: 13,
    overflow: "hidden",
    padding: 26,
    backgroundColor: "transparent",
    color: "#D3D3D3",
    fontFamily: "Courier, monospace",
    fontSize: 15,
  };

  const codeContainerStyle = {
    display: "flex",
    backgroundColor: "#0d1b2af7",
    border: "1px solid #0a1725cc",
    borderRadius: 8,
    overflow: "hidden",
    fontFamily: "Courier, monospace",
    fontSize: 15,
    lineHeight: 1.5,
    flexDirection: "row",
  };

  const lineNumbersStyle = {
    padding: "16px 10px",
    textAlign: "right",
    userSelect: "none",
    color: "#5C6773",
    backgroundColor: "#0C1624",
  };

  const codeStyle = {
    padding: "16px",
    whiteSpace: "pre-wrap",
    color: "#C0C0C0",
    flex: 1,
  };

  const contentLines = [
    [{ text: "// Om os - Netcompose", color: "#6A9955" }],
    [
      { text: "Netcompose", color: "#569CD6" },
      { text: " er et moderne ", color: "#C0C0C0" },
      { text: "softwarestudie", color: "#4EC9B0" },
      { text: " med fokus på ", color: "#C0C0C0" },
      { text: "Kotlin Multiplatform", color: "#C586C0" },
      { text: ".", color: "#C0C0C0" },
    ],
    [
      { text: "Vi specialiserer os i at udvikle ", color: "#C0C0C0" },
      { text: "hurtige", color: "#D7BA7D" },
      { text: ", ", color: "#C0C0C0" },
      { text: "vedligeholdelsesvenlige", color: "#D16969" },
      { text: " web- og mobilapplikationer ved hjælp af ", color: "#C0C0C0" },
      { text: "Compose", color: "#D16969" },
      { text: ".", color: "#C0C0C0" },
    ],
    [
      { text: "Vores mål er at levere ", color: "#C0C0C0" },
      { text: "elegante", color: "#D69D85" },
      { text: ", ", color: "#C0C0C0" },
      { text: "effektive", color: "#D7BA7D" },
      { text: " og ", color: "#C0C0C0" },
      { text: "skalerbare", color: "#4EC9B0" },
      { text: " løsninger,", color: "#C0C0C0" },
    ],
    [
      { text: "der opfylder både ", color: "#C0C0C0" },
      { text: "brugernes behov", color: "#9CDCFE" },
      { text: " og ", color: "#C0C0C0" },
      { text: "forretningskrav", color: "#CE9178" },
      { text: ".", color: "#C0C0C0" },
    ],
    [{ text: "    ", color: "#6A9955" }],
    [
      { text: "vores_teknologistack() ", color: "#D7BA7D" },
      { text: "{ ", color: "#C0C0C0" },
    ],
    [
      { text: "   Kotlin Multiplatform", color: "#C586C0" },
      { text: " for cross-platform development", color: "#C0C0C0" },
    ],
    [
      { text: "   Jetpack Compose", color: "#6A9955" },
      { text: " for", color: "#C0C0C0" },
      { text: " kotlin", color: "#C586C0" },
      { text: " UI", color: "#C0C0C0" },
    ],
     [
      { text: "   Replit", color: "#ff9100" },
      { text: " for API integration", color: "#C0C0C0" },
    ],
    [
      { text: "   React", color: "#00D8FF" },
      { text: " for webudvikling", color: "#C0C0C0" },
    ],
    [
      { text: "   Firebase", color: "#ff9100" },
      { text: " for cloud infrastructure", color: "#C0C0C0" },
    ],
    [{ text: "}", color: "#C0C0C0" }],
    [{ text: "  ", color: "#C0C0C0" }],
    [{ text: "// Vores Services", color: "#6A9955" }],
  ];

  const services = [
    { icon: MdPhoneAndroid, label: "= Mobile App Development", color: "#3DDC84" },
    { icon: MdComputer, label: "= Desktop App Development", color: "#4285F4" },
    { icon: MdLanguage, label: "= Web development", color: "#A9A9A9" },
    { icon: MdLocalFireDepartment, label: "= Firebase integration", color: "#ff9100" },
    { icon: MdCloud, label: "= Backend Integration & APIs", color: "#90CAF9" },
    { icon: MdLightbulb, label: "= MVP Prototyping", color: "#FFEB3B" },
  ];

  const serviceLineStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    //paddingLeft: 16,
    color: "#C0C0C0",
    fontFamily: "Courier, monospace",
    fontSize: 15,
    marginTop: 2,
  };

  return (
    <div style={outerStyle}>
      <div style={innerStyle}>
        <div style={{ position: "relative", zIndex: 1 }}>
          <div style={codeContainerStyle}>
           <div style={lineNumbersStyle}>
            <div>1</div>
            <div>2</div>
            <div>3</div>
            <div>4</div>
            <div>5</div>
            <div>6</div>
            <div>7</div>
            <div>8</div>
            <div>9</div>
            <div>10</div>
            <div>11</div>
            <div>12</div>
            <div>13</div>
            <div>14</div>
            <div>15</div>
            <div>16</div>
            <div>17</div>
            <div style={{ lineHeight: "1.8em" }}>18</div>
            <div style={{ lineHeight: "1.6em" }}>19</div>
            <div style={{ lineHeight: "1.6em" }}>20</div> {/* first service line taller */}
            <div style={{ lineHeight: "1.6em" }}>21</div>
            <div style={{ lineHeight: "1.6em" }}>22</div>
            <div style={{ lineHeight: "1.6em" }}>23</div>
            <div style={{ lineHeight: "1.6em" }}>24</div>
            <div style={{ lineHeight: "1.6em" }}>25</div>
          </div>
            <div style={codeStyle}>
              {contentLines.map((line, i) => (
                <div key={i}>
                  {line.map((segment, j) => (
                    <span key={j} style={{ color: segment.color }}>
                      {segment.text}
                    </span>
                  ))}
                </div>
              ))}

              {/* Services as additional "lines" with icons */}
              {services.map(({ icon: Icon, label, color }, i) => (
                <div key={i} style={serviceLineStyle}>
                  <Icon size={18} color={color} />
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


function AboutSection() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    function onScroll() {
      setScrollY(window.scrollY);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const visible = scrollY > 200;

  const outerStyle = {
    position: "relative",
    maxWidth: 660,
    width: "100%",
    margin: "40px auto",
    borderRadius: 18,
    padding: 5, // this becomes the border thickness
    background: "linear-gradient(135deg, #083042, #114a2b)", // gradient border
    boxSizing: "border-box",
  };

  const headerStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: 40,
    color: "lightgray",
  };

  const innerStyle = {
    borderRadius: 13,
    overflow: "hidden",
    position: "relative", // needed for overlay
    backgroundImage: `url(${kodeImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: 26,
    color: "#D3D3D3",
    fontFamily: "MyCustomFont, sans-serif",
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0)" : "translateY(20px)",
    transition: "opacity 0.5s ease, transform 0.5s ease",
  };

  // Overlay to add blur effect behind the text
  const overlayStyle = {
    position: "absolute",
    inset: 0,
    backdropFilter: "blur(3px)", // <-- this adds the blur
    backgroundColor: "rgba(0,0,0,0.3)", // optional dark overlay
    borderRadius: 13,
    zIndex: 0, // behind text
  };

  const contentStyle = {
    position: "relative",
    zIndex: 1, // text above blur
    padding: 10,
    borderRadius: 10,
  };


  return (
    <div style={outerStyle}>
      <div style={innerStyle}>
        <div style={overlayStyle} /> {/* blur layer */}
        <div style={{ position: "relative", zIndex: 1 }}>
          <div style={headerStyle}>
            <MdInfo size={24} color="lightgray" />
            <div style={{ width: 8 }} />
            <h2 style={{ fontSize: 22, fontWeight: "bold", margin: 0 }}>Om os</h2>
          </div>

          <div style={contentStyle}>
            <p style={{ fontSize: 16, color: "gray", lineHeight: 1.5 }}>
              Netcompose er et moderne softwarestudie med fokus på Kotlin Multiplatform. Vi specialiserer os i at udvikle hurtige, vedligeholdelsesvenlige web- og mobilapplikationer ved hjælp af Compose. Vores mål er at levere elegante, effektive og skalerbare løsninger, der opfylder både brugernes behov og forretningskrav.
            </p>
          </div>
        </div>
      </div>
    </div>

  );
}

function ContactSection() {
  const containerStyle = {
    padding: 30,
    opacity: 1,
    fontSize: 13,
    transform: "translateY(0)",
    transition: "none",
    color: "#D3D3D3",
    fontFamily: "MyCustomFont, sans-serif",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: 60,
  };

  const columnStyle = {
    maxWidth: 300,
    textAlign: "left",
  };

  const titleStyle = {
    fontSize: 22,
    fontWeight: "bold",
    margin: 0,
  };

  const footerStyle = {
    width: "100%",
    textAlign: "center",
    marginTop: 20,
    fontSize: 12,
    color: "#555",
    padding: 20,
  };

  return (
    <div>
      <div style={containerStyle}>

        {/* LEFT — Firma-info */}
        <div style={columnStyle}>
          <h2 style={titleStyle}>Netcompose I/S</h2>
          <div style={{ height: 8 }}></div>

          <p style={{ color: "#888" }}>CVR: 45561631</p>

          <p style={{ color: "#888" }}>
            c/o Nicklas Pedersen<br />
            Piloq 4 102<br />
            3905 Nuussuaq<br />
            Kommune Sermersooq
          </p>

          <p style={{ color: "#888" }}>Email: nicklas@pajussi.com</p>
          <p style={{ color: "#888" }}>Telefon: +299 24 05 50</p>
        </div>

        {/* MIDDLE — Kontakt */}
        <div style={columnStyle}>
          <h2 style={titleStyle}>Kontakt os</h2>
          <div style={{ height: 8 }}></div>

          <p style={{ color: "#888" }}>support@netcompose.gl</p>
          <p style={{ color: "#888" }}>julius@netcompose.gl</p>
          <p style={{ color: "#888" }}>nicklas@netcompose.gl</p>
          <p style={{ color: "#888" }}>www.netcompose.gl</p>
        </div>

        {/* RIGHT — Nyttige links */}
        <div style={columnStyle}>
          <h2 style={titleStyle}>Nyttige links</h2>
          <div style={{ height: 8 }}></div>

          <a 
            href="https://netcompose.gl/privacy"
            style={{ color: "#888", textDecoration: "none", display: "block", marginBottom: 10, marginTop: 12 }}
          >
            Privatlivspolitik
          </a>

          <a 
            href="https://netcompose.gl/terms"
            style={{ color: "#888", textDecoration: "none", display: "block", marginBottom: 12 }}
          >
            Vilkår & betingelser
          </a>
        </div>

      </div>

      {/* CENTERED COPYRIGHT */}
      <div style={footerStyle}>
        © {new Date().getFullYear()} Netcompose. Alle rettigheder forbeholdt.
      </div>
    </div>
  );
}


export { ServicesSection, AboutSection, ContactSection, AboutSectionPlayful };
